export const VAAS_COURSES_QUERY_KEY = ["vaas", "courses"] as const
